var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section',{staticClass:"hero"},[_c('NavBar'),_c('MainSearch'),_c('b-link',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:('#champ-cinema'),expression:"'#champ-cinema'"}],staticClass:"scroll-down align-items-end",attrs:{"href":"#"}},[_vm._v("Explore"),_c('font-awesome-icon',{attrs:{"icon":['fas', 'caret-down']}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }